module.exports = __webpack_public_path__ + "static/media/call4.91b17693.png";